import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import {
  DatePipe,
} from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'td[eurogard-date-cell]',
  templateUrl: './date-cell.component.html',
  styleUrls: [ './date-cell.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ DatePipe ],
})
export class DateCellComponent {

  @Input('eurogard-date-cell')
  public date: Date | number | string | null = null;

  @Input()
  public format = 'dd.MM.yyyy HH:mm';

}
